import { inject, Injectable } from "@angular/core";
import { Admission, AdmissionPart, FullAdmissionsData } from "./gestion.service";
import { CartService } from "app/Cart/CartService";
import { QdmService } from "./qdm.service";

@Injectable({
    providedIn: 'root'
})
export class AdmissionService {
    private cart = inject(CartService);

    getRemainingQuantity(
        svc_id?: number,
        rankId?: number,
        restaurantId?: number,
        childId?: number,
        date?: Date,
        groupOrderQuantity?: number,
        admission?: FullAdmissionsData
    ): number {
        if (!svc_id || !rankId || !admission || !restaurantId || !childId || !date || !groupOrderQuantity) {
          return 0;
        }
    
        const componentId = rankId;
        const admissionQuantities =
          admission.admissionParts.find(
            (part) => part.serviceId === componentId
          );
    
        if (!admissionQuantities) {
          return 0;
        }

        const cartItems = this.cart.getCartFor(
          svc_id,
          restaurantId,
          childId,
          date
        );
    
        const nbOfVeganFullCourses = cartItems.filter((item) => item.isVeganFullCourse).reduce((acc, item) => acc + item.quantity, 0);
        const nbOfMeatFullCourses = cartItems.filter((item) => item.isMeatFullCourse).reduce((acc, item) => acc + item.quantity, 0);
        
        let usedQuantity = cartItems
          .filter((item) => item.rankId === componentId)
          .reduce((acc, item) => acc + item.quantity, 0);

        if(admissionQuantities.isLegume){
          usedQuantity += nbOfVeganFullCourses + nbOfMeatFullCourses;
        }
    
        return Math.max(
          0,
          admissionQuantities.quantity * groupOrderQuantity -
            usedQuantity
        );
      }
}
